<template>
  <div>
    <b-navbar class="nav-on-top" toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand>
        <!-- <img
          src="https://www.anvelope.ro/wp-content/themes/anvelope/images/favicon-96x96.png"
          alt="logo"
          style="max-height: 35px; margin-left: 15px"
        /> -->
      </b-navbar-brand>

      <b-navbar-toggle
        style="margin-left: 10px"
        target="nav_collapse"
      ></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse" class="menu-bar">
        <b-navbar-nav class="ml-auto" style="padding: 5px">
            <b-nav-item v-if="($has_right('Management') || $has_right('Supervizor') || $has_right('Receptie')) && (!$has_right('AjutorMontator'))"                   
            href='#/rezervari'          
            class='rezervari'> Programari </b-nav-item>

            <b-nav-item-dropdown right  v-if="($has_right('Management') || $has_right('Supervizor')) && !$has_right('AjutorMontator')">
            <template #button-content>
                Flote
              </template>
            <b-dropdown-item v-if="($has_right('Management') || $has_right('Supervizor')) && !$has_right('AjutorMontator')"                               
            href='#/flote'              
            class='flote'> Flote </b-dropdown-item>
            <b-dropdown-item v-if="($has_right('Management') || $has_right('Supervizor')) && !$has_right('AjutorMontator')"                               
            href='#/manageri_flote'     
            class='manageri_flote'> Manageri </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right  v-if="$has_right('Management') && !$has_right('AjutorMontator')"  >
              <template #button-content>
                 Produse
              </template>
              <b-dropdown-item v-if="$has_right('Management') && !$has_right('AjutorMontator')"                                                                
              href="#/categorii_produse"  class="categorii_produse">Categorii produse</b-dropdown-item>
              <b-dropdown-item v-if="$has_right('Management') && !$has_right('AjutorMontator')"                                                                
              href="#/produse"  class="produse">Produse</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right  v-if="$has_right('Management') && !$has_right('AjutorMontator')" class="clienti_cat" >
              <template #button-content>
                 Clienti
              </template>
              <b-dropdown-item v-if="$has_right('Management') && !$has_right('AjutorMontator')"                                                                
              href="#/clienti"  class="clienti">Clienti</b-dropdown-item>
              <b-dropdown-item v-if="$has_right('Management') && !$has_right('AjutorMontator')"                                                                
              href="#/masini"  class="masini">Masini</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right class="devize" v-if="!$has_right('AjutorMontator')">
              <template #button-content>
                 Devize
              </template>
                <b-dropdown-item  v-if="$has_right('Supervizor') && !$has_right('AjutorMontator')"    href='#/devize_draft'  class='devize_draft'> Devize la mecanici </b-dropdown-item >
                <b-dropdown-item  v-if="($has_right('Supervizor') || $has_right('Management')) && !$has_right('AjutorMontator')"    href='#/devize_in_lucru'  class='devize_in_lucru'> Devize in lucru </b-dropdown-item >
                <b-dropdown-item  v-if="$has_right('Mecanic') && !$has_right('AjutorMontator')" href='#/devize_draft'       class='devize'> Devize </b-dropdown-item >
                <b-dropdown-item  v-if="($has_right('Management') || $has_right('Receptie')) && !$has_right('AjutorMontator')"  href='#/devize_finalizate'  class='devize_finalizate'> Devize finalizate </b-dropdown-item >
                <b-dropdown-item  v-if="($has_right('Management') || $has_right('Receptie')) && !$has_right('AjutorMontator')"  href='#/devize_nefacturate' class='devize_nefacturate'> Devize nefacturate </b-dropdown-item >
                <b-dropdown-item  v-if="$has_right('Supervizor') && !$has_right('AjutorMontator')"    href='#/devize_de_aprobat'  class='devize_de_aprobat'> Devize de aprobat </b-dropdown-item >
                <b-dropdown-item  v-if="loggedUserId == desiredUserId"    href='#/devize_inchise_fara_factura'  class='devize_inchise_fara_factura'> Devize inchise fara factura </b-dropdown-item >
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right v-if="($has_right('Management') || $has_right('Mecanic')) && !$has_right('AjutorMontator')" >
              <template #button-content>
                 Rapoarte
              </template>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_mecanici'    class='raport_mecanici'> Raport general </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_analiza'     class='raport_analiza'> Raport analiza </b-dropdown-item> 
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_grad_ocupare'     class='raport_grad_ocupare'> Raport grad ocupare </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_rar'         class='raport_rar'> Raport RAR </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/actiuni'            class='actiuni'> Actiuni </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/istoric_login'      class='istoric_login'> Istoric login </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/istoric_programari'      class='istoric_programari'> Istoric programari </b-dropdown-item> 
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/istoric_sms'      class='istoric_sms'> Istoric SMS-uri </b-dropdown-item> 
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/istoric_email'      class='istoric_email'> Istoric emailuri </b-dropdown-item> 
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_anulari'     class='raport_anulari'> Raport anulari programari </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_anulari_devize' class='raport_anulari_devize'> Raport devize sterse </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_produse'  class='raport_mecanici'> Raport produse </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_devize_penalizate'  class='raport_devize_penalizate'> Raport devize penalizate </b-dropdown-item>
                <b-dropdown-item v-if="1==2 &$has_right('Mecanic')"                                                             
                href='#/raport_produse_mecanici'  class='raport_mecanici'> Raport produse </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_produse_utilizator'  class='raport_produse_utilizator'> Raport produse / utilizator</b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_produse_deviz'  class='raport_produse_deviz'> Raport produse / deviz</b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_adaugare_produse_deviz'  class='raport_adaugare_produse_deviz'> Raport adaugare produse / deviz</b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"                                                             
                href='#/raport_comenzi_neasociate'  class='raport_comenzi_neasociate'> Raport comenzi neasociate</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right v-if="($has_right('Management') || $has_right('Supervizor')) && !$has_right('AjutorMontator')"  class='setari' >
              <template #button-content>
                 Setari
              </template>
                <b-dropdown-item v-if="$has_right('Management')" href='#/utilizatori'             class='utilizatori'> Utilizatori </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')" href='#/utilizatori_penalizare'  class='utilizatori_penalizare'> Utilizatori penalizare </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')" href='#/centre_productie'        class='centre_productie'> Centre productie </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')" href='#/marci_masini'            class='marci_masini'> Marci masini </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')" href='#/tipuri_masini'           class='tipuri_masini'> Tipuri masini </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')" href='#/servicii_programator'    class='servicii_programator'> Servicii programator </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Supervizor')" href='#/semnatura'               class='semnatura'> Semnatura </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"  href='#/consimtamant'            class='consimtamant'> Consimtamant </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"  href='#/zile_libere'             class='utilizatori_zile_libere'> Zile libere </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"  href='#/setari'                  class='setari'> Setari </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"  href='#/setari_sms'              class='setari_sms'> Setari SMS </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"  href='#/setari_email'            class='setari_email'> Setari Email </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"  href='#/setari_programator'      class='setari_programator'> Setari programator </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"  href='#/limitare_rezervari'      class='limitare_rezervari'> Limitare programator </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"  href='#/blocare_masini'          class='blocare_masini'> Masini blocate </b-dropdown-item>
                <b-dropdown-item v-if="$has_right('Management')"  href='#/conditii_garantie'       class='conditii_garantie'> Conditii de garantie </b-dropdown-item>
          </b-nav-item-dropdown>
                
           
          <b-nav-item-dropdown right v-if="!$has_right('AjutorMontator')">
            <template #button-content>Cont</template>
              <b-dropdown-item  v-if="!$has_right('Mecanic')"  @click="change_password()"> Schimbare parola</b-dropdown-item>
              <b-dropdown-item  v-if="$has_right('Mecanic')"  @click="change_pin()"> Schimbare pin</b-dropdown-item>
              <b-dropdown-item v-if="!$has_right('AjutorMontator')" @click="onLogout()" right> Iesire cont</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-if="($has_right('Management') || $has_right('Supervizor') || $has_right('Receptie')) && !$has_right('AjutorMontator')"                   
            @click="adauga_rezervare()" class='adauga_programare' ><i class="el-icon-plus success" type="warning"></i> Adauga programare </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
      <el-tooltip class="item" effect="dark" content="Devize nefacturate">
      <div class="v-badge">
        {{nrDevizeNefacutate}}
        <span></span>
      </div>
      </el-tooltip>
    </b-navbar>
    
    <change-password-dialog ref="changePassDlg"></change-password-dialog>
    <change-pin-dialog ref="changePinDlg"></change-pin-dialog>
  </div>
</template>

<script>
import settings from "@/backend/LocalSettings";
import ChangePassword_dialog from "@/pages/Admin/ChangePassword_dialog";
import ChangePin_dialog from "@/pages/Admin/ChangePin_dialog";

export default {
  name: "Login",
  data() {
    return {
      user_type: "",
      timeout:null,
      nrDevizeNefacutate:0,
      loggedUserId:'',
      desiredUserId:'',
    };
  },
  components: {
    "change-password-dialog": ChangePassword_dialog,
    "change-pin-dialog": ChangePin_dialog,
  },
  methods: {
    post: async function (url, args = {}) {
      this.loadingVisible = true;
      var response = await this.$http.post(url, args);
      this.loadingVisible = false;
      if (settings.verify_response(response)) {
        return response.body;
      } else {
        this.$router.push("/").catch(()=>{});
      }
    },

    adauga_rezervare: function () {
      this.$router.push('adauga_rezervare').catch(()=>{});
    },
    
    change_password: function () {
      this.$refs["changePassDlg"].show_me();
    },
    
    change_pin: function () {
      this.$refs["changePinDlg"].show_me();
    },

    async onLogout() {
      var response = await this.post('login/logout', { } );
      if( response.Success == 1 ){
        settings.logout();
        this.$router.push("/").catch(()=>{});
      }
    },
    async getNrDevizeNefacturate() {
      const response = await this.post("receptie/devize/get_nr_devize_nefacturate");
      this.nrDevizeNefacutate = response.devize_nefacturate.Numar;

      if(this.timeout){
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => this.getNrDevizeNefacturate(), 1000 * 30); 
    },

    async getLoggedUserId(){
      try {
        const response = await this.post("receptie/devize/get_logged_user_id");
        if(response && response.userId){
          this.loggedUserId = response.userId;
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
 async mounted() {
    this.user_type = settings.get_user_type();
    this.getNrDevizeNefacturate();

    this.loggedUserId = null;
    this.desiredUserId = null;

    if (window.location.href.includes("localhost") || window.location.href.includes("dev")) {
      this.desiredUserId = 33;
    }else{
      this.desiredUserId = 18;
    }
    await this.getLoggedUserId();
    // this.user_name = settings.get_user_name();
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus,
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .nav-link.active {
  color: hsl(193, 11%, 34%) !important;
  opacity: 0.5 !important;
}

.text {
  display: none;
}

.icon:hover + .text {
  display: inline;
}

.navbar-toggler {
  background-color: hsl(193, 11%, 34%) !important;
}

.el-header {
  padding: 0;
}
.nav-on-top {
  width: 100%;
  z-index: 1000;
}

.navbar {
  width: 100%;
  padding: 10px;
}

.bg-dark {
  background-color: hsla(0, 0%, 100%, 0.9) !important;
}

.navbar-dark .navbar-nav .nav-link {
  color: hsl(193, 11%, 34%);
  text-transform: uppercase;
  margin: 0 5.5px;
  font-size: 13px;
  transition: 0.3s;
}

#navbar-toggler-icon,
.navbar-toggler {
  color: hsl(193, 11%, 34%) !important;
}

.navbar,
.navbar-dark {
  box-shadow: 0 0.3px 0.5px 0 rgba(0, 0, 0, 0.2),
    0 3px 5px 0 rgba(0, 0, 0, 0.19);
}

.navbar-dark .active .nav-link {
  background-color: hsla(193, 11%, 34%, 0.126);
  border-radius: 10px;
  color: hsl(193, 11%, 34%) !important;
}

.dropdown-menu {
  border: none;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.nav-link {
  width: max-content !important;
}

.dropdown-item {
  color: hsl(193, 11%, 34%) !important;
}

.menu-bar,
.navbar-collapse,
.collapse {
  width: 100% !important;
}

@media only screen and (min-width: 992px) {
  .nav-bar-overflow {
    // overflow-x: scroll;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  // .nav-on-top {
  // }
  .overflow-nav {
    overflow-x: initial;
    overflow-y: inherit;
    width: 90% !important;
  }
}
@media only screen and (max-width: 991px) {
  .nav-on-top {
    width: 100% !important;
    overflow: hidden;
  }
}

::-webkit-scrollbar {
  display: none;
}

.v-badge {
  position: relative;
  text-decoration: none;
  padding: 2px 12px;
  color: white;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  background: linear-gradient(to bottom, #9f303f, #ff0011);
  border-radius: 999px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  user-select: none;
}

.v-badge span {
  width: 25px;
  height: 25px;
  position: absolute;
  top: -12px;
  right: -2px;
  transform: rotate(-20deg);
  filter: blur(0.5px);
}

.v-badge span:before,
.v-badge span:after {
  content: "";
  position: absolute;
}

.v-badge span:before {
  width: 1px;
  height: 100%;
  left: 12px;
  background: linear-gradient(to bottom, transparent, rgba(20, 20, 20, 0.7), transparent);
}

.v-badge span:after {
  width: 100%;
  height: 1px;
  top: 12px;
  background: linear-gradient(to left, transparent, rgba(20, 20, 20, 0.7), transparent);
}

.v-badge:before {
  content: "";
  position: absolute;
  z-index: -1;
  background: linear-gradient(30deg, #ff0004 60%, white); /* Slightly lightened mid-tone color */
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  border-radius: 999px;
}

.inspired {
  position: absolute;
  bottom: 8%;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  text-decoration: none;
  transition: color 0.2s ease;
}

.inspired:hover {
  color: rgba(255, 255, 255, 0.8);
}

</style>
